import * as Domain from './domain'

export const practicePlayerModules = [
  Domain.practiceSessionDomainModule,
]
